import {setSaveButtonActive} from './work-save-button-toggle';

const AI_TEXT_FIELD_TYPE = '13';
const COOLDOWN_DEFAULT_SECONDS = 30;

let cooldownTimerId = null;

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function pluralizeViolations(count) {
  const mod10 = count % 10;
  const mod100 = count % 100;

  if (mod10 === 1 && mod100 !== 11) {
    return 'нарушение';
  }

  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    return 'нарушения';
  }

  return 'нарушений';
}

function getTagClass(tag) {
  const normalized = String(tag || '').toLowerCase();

  if (normalized.includes('услов')) {
    return 'ai-text-work-field-verification__tag_warning';
  }

  return 'ai-text-work-field-verification__tag_error';
}

function clearAiTextFieldStates() {
  document.querySelectorAll('.custom_ai_text_work_field').forEach((field) => {
    field.classList.remove('custom_ai_text_work_field_error');

    const verificationBlock = field.querySelector('.ai-text-work-field-verification');
    if (verificationBlock) {
      verificationBlock.hidden = true;
      verificationBlock.innerHTML = '';
      verificationBlock.className = 'ai-text-work-field-verification';
    }
  });
}

function renderViolationsBlock(fieldElement, payload) {
  const verificationBlock = fieldElement.querySelector('.ai-text-work-field-verification');

  if (!verificationBlock) {
    return;
  }

  const violations = payload.violations || [];
  const count = payload.violationsCount || violations.length;
  const itemsHtml = violations.map((violation) => {
    const tag = violation.tag || 'Нарушение';
    const reason = violation.reason || '';

    return `
      <div class="ai-text-work-field-verification__item">
        <span class="ai-text-work-field-verification__tag ${getTagClass(tag)}">${escapeHtml(tag)}</span>
        ${reason ? `<div class="ai-text-work-field-verification__reason">${escapeHtml(reason)}</div>` : ''}
      </div>
    `;
  }).join('');

  verificationBlock.hidden = false;
  verificationBlock.className = 'ai-text-work-field-verification ai-text-work-field-verification_error';
  verificationBlock.innerHTML = `
    <div class="ai-text-work-field-verification__title">
      <span class="ai-text-work-field-verification__icon" aria-hidden="true">!</span>
      Заявку нельзя отправить: найдено ${count} ${pluralizeViolations(count)}
    </div>
    <div class="ai-text-work-field-verification__items">${itemsHtml}</div>
    <div class="ai-text-work-field-verification__hint">
      Отредактируйте выделенные фрагменты и сохраните снова. Проверка выполняется автоматически при каждом сохранении.
    </div>
  `;
}

function renderServiceErrorBlock(fieldElement) {
  const verificationBlock = fieldElement.querySelector('.ai-text-work-field-verification');

  if (!verificationBlock) {
    return;
  }

  verificationBlock.hidden = false;
  verificationBlock.className = 'ai-text-work-field-verification ai-text-work-field-verification_warning';
  verificationBlock.innerHTML = `
    <div class="ai-text-work-field-verification__title">
      <span class="ai-text-work-field-verification__icon ai-text-work-field-verification__icon_warning" aria-hidden="true">!</span>
      Не удалось проверить текст
    </div>
    <div class="ai-text-work-field-verification__reason">
      Сервис проверки временно недоступен. Попробуйте ещё раз через несколько минут.
    </div>
  `;
}

export function hasAiTextFieldsForVerification() {
  return Array.from(document.querySelectorAll('.custom_ai_text_work_field')).some((field) => {
    const textarea = field.querySelector('textarea');

    return textarea && textarea.value.trim() !== '';
  });
}

export function shouldRunAiTextVerificationOnSave(saveBtn, sendUrl) {
  if (!saveBtn || !sendUrl) {
    return false;
  }

  const fullSaveUrl = saveBtn.getAttribute('data-url');

  return sendUrl === fullSaveUrl && hasAiTextFieldsForVerification();
}

export function showAiTextVerificationLoading() {
  const statusBlock = document.getElementById('ai-text-work-field-save-status');
  const cooldownBlock = document.getElementById('ai-text-work-field-cooldown');

  if (statusBlock) {
    statusBlock.hidden = false;
  }

  if (cooldownBlock) {
    cooldownBlock.hidden = true;
  }
}

export function hideAiTextVerificationLoading() {
  const statusBlock = document.getElementById('ai-text-work-field-save-status');

  if (statusBlock) {
    statusBlock.hidden = true;
  }
}

function updateCooldownText(seconds) {
  const cooldownBlock = document.getElementById('ai-text-work-field-cooldown');
  const textNode = cooldownBlock?.querySelector('.ai-text-work-field-cooldown__text');

  if (!cooldownBlock || !textNode) {
    return;
  }

  cooldownBlock.hidden = false;
  textNode.textContent = `Следующая проверка будет доступна через ${seconds} секунд...`;
}

export function startAiTextVerificationCooldown(seconds = COOLDOWN_DEFAULT_SECONDS, saveBtn = null) {
  if (typeof window.__hideWbStepLoader === 'function') {
    window.__hideWbStepLoader();
  }

  if (cooldownTimerId) {
    clearInterval(cooldownTimerId);
  }

  let remaining = seconds;
  updateCooldownText(remaining);

  if (saveBtn) {
    saveBtn.disabled = true;
    saveBtn.classList.add('opacity-50');
    const buttonText = saveBtn.querySelector('span');
    if (buttonText) {
      buttonText.textContent = 'Сохранить и продолжить';
    }
  }

  cooldownTimerId = window.setInterval(() => {
    remaining -= 1;

    if (remaining <= 0) {
      clearInterval(cooldownTimerId);
      cooldownTimerId = null;

      const cooldownBlock = document.getElementById('ai-text-work-field-cooldown');
      if (cooldownBlock) {
        cooldownBlock.hidden = true;
      }

      if (saveBtn) {
        setSaveButtonActive(saveBtn);
      }

      return;
    }

    updateCooldownText(remaining);
  }, 1000);
}

export function handleAiTextVerificationResponse(data, saveBtn) {
  clearAiTextFieldStates();

  const payloads = Array.isArray(data?.aiTextVerification) ? data.aiTextVerification : [];

  if (!payloads.length) {
    return false;
  }

  let cooldownSeconds = 0;

  payloads.forEach((payload) => {
    if (payload.type === 'cooldown') {
      cooldownSeconds = Math.max(cooldownSeconds, Number(payload.cooldownSeconds) || COOLDOWN_DEFAULT_SECONDS);
      return;
    }

    const fieldElement = payload.workFieldUuid
      ? document.querySelector(`.custom_work_field[data-uuid="${payload.workFieldUuid}"]`)
      : null;

    if (!fieldElement) {
      return;
    }

    fieldElement.classList.add('custom_ai_text_work_field_error');

    if (payload.type === 'service_error') {
      renderServiceErrorBlock(fieldElement);
      return;
    }

    if (payload.type === 'violations') {
      renderViolationsBlock(fieldElement, payload);
      cooldownSeconds = Math.max(cooldownSeconds, COOLDOWN_DEFAULT_SECONDS);
    }
  });

  if (typeof window.__hideWbStepLoader === 'function') {
    window.__hideWbStepLoader();
  }

  if (cooldownSeconds > 0) {
    startAiTextVerificationCooldown(cooldownSeconds, saveBtn);
    return true;
  }

  return false;
}

export { AI_TEXT_FIELD_TYPE };
